<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <h3 class="mb-0">Listado de usuarios solicitaron tarjeta go</h3>
            </b-card-header>

            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      :data="tableData">
              <el-table-column label="Nombres"
                               prop="first_name">
              </el-table-column>
              <el-table-column label="Apellidos"
                               prop="last_name"
                               >
              </el-table-column>

              <el-table-column label="Pais - Ciudad"
                               prop="country">
              </el-table-column>
              <el-table-column label="Direccion"
                               prop="address">
              </el-table-column>
              <el-table-column label="Identification"
                               prop="ID">
              </el-table-column>
              <el-table-column label="ZIP"
                               prop="zip_code">
              </el-table-column>
              <el-table-column label="Tarjeta activa?" prop="isActive">
                <template v-slot="{row}">
                  {{ row.active|status }}
                </template>
              </el-table-column>
              <el-table-column label="Fecha registro" prop="created_at">
                <template v-slot="{row}">
                  {{ row.created_at|formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="Opciones" fixed="right">
                <template slot="header" slot-scope="scope">
                  <input
                    v-model="search" class="el-input__inner" @keyup.enter="load"
                    size="mini"
                    placeholder="Filtro"/>
                </template>
                <template v-slot="{row}">
                  <button class="btn btn-sm btn-outline-primary" @click="active(row)" title="Cambiar estado de la tarjeta">
                    <i class="ni ni-check-bold"></i>
                  </button>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination v-model="currentPage" :per-page="20" :total="total" @change="paginate"></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "GoCard",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    tableData: [],
    currentPage: 1,
    total: 0,
    search: ''
  }),
  methods: {
    load() {
      get(`go-card/list?page=${this.currentPage}&limit=20&search=${this.search}`, null, true)
        .then(({data}) => {
          this.tableData = data.data;
          this.total = data.count
        })
    },
    paginate(page){
      this.currentPage = page;
      this.load()
    },
    active(row) {
      post(`go-card/active/${row._id}`, {active: !row.active}).then(() => {
        this.load()
      })
    },
    handleSearch(){
      this.load()
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style scoped>

</style>
